import { Component } from 'vue'
import HebergementSVG from '../components/svg/package/HebergementSVG.vue'
import SkipassSVG from '../components/svg/package/SkipassSVG.vue'
import MaterielSVG from '../components/svg/package/MaterielSVG.vue'
import TrainSVG from '../components/svg/package/TrainSVG.vue'

export type PackConfigValue = {
    field: string
    id: string
}
export type LocalePackConfig = {
    label: string
    values: PackConfigValue[]
    icons?: Component[]
}[]
export type PackConfig = {
    [locale: string]: LocalePackConfig
}

const packConfig: PackConfig = {
    fr_FR: [
        {
            label: 'Hébergement',
            values: [
                {
                    field: 'packages',
                    id: 'HS'
                }
            ],
            icons: [HebergementSVG]
        },
        {
            label: 'Hébergement + Skipass',
            values: [
                {
                    field: 'packages',
                    id: 'PF'
                }
            ],
            icons: [HebergementSVG, SkipassSVG]
        },
                {
            label: 'Hébergement + Skipass + Matériel',
            values: [
                {
                    field: 'packages',
                    id: 'PFP'
                }
            ],
            icons: [HebergementSVG, SkipassSVG, MaterielSVG]
        },
        {
            label: 'Train + Héb. + Skipass',
            values: [
                {
                    field: 'packages',
                    id: 'PFTTF'
                }
            ],
            icons: [TrainSVG, HebergementSVG, SkipassSVG]
        },
        {
            label: ' Train + Héb. + Skipass + Matériel',
            values: [
                {
                    field: 'packages',
                    id: 'PFPTTF'
                }
            ],
            icons: [TrainSVG, HebergementSVG, SkipassSVG, MaterielSVG]
        },
        {
            label: 'Héb.  + Skipass - Court-séjour',
            values: [
                {
                    field: 'packages',
                    id: 'PFCS'
                }
            ],
            icons: [HebergementSVG, SkipassSVG]
        },
        {
            label: 'Héb. + Skipass + Matériel - Court-séjour',
            values: [
                {
                    field: 'packages',
                    id: 'PFPCS'
                }
            ],
            icons: [HebergementSVG, SkipassSVG, MaterielSVG]
        },
        {
            label: 'Héb.  + Pass Multi Activité',
            values: [
                {
                    field: 'packages',
                    id: 'PMA'
                }
            ],
            icons: [HebergementSVG]
        },
        {
            label: 'Héb.  + Skipass',
            values: [
                {
                    field: 'packages',
                    id: 'OPPF'
                }
            ],
            icons: [HebergementSVG, SkipassSVG]
        },
        {
            label: 'Héb.  + Skipass + Matériel',
            values: [
                {
                    field: 'packages',
                    id: 'OPPFCS'
                }
            ],
            icons: [HebergementSVG, SkipassSVG, MaterielSVG]
        },
        {
            label: 'Héb.  + Skipass + Matériel',
            values: [
                {
                    field: 'packages',
                    id: 'OPPFP'
                }
            ],
            icons: [HebergementSVG, SkipassSVG, MaterielSVG]
        },
        {
            label: 'Héb.  + Skipass + Matériel',
            values: [
                {
                    field: 'packages',
                    id: 'OPPFPCS'
                }
            ],
            icons: [HebergementSVG, SkipassSVG, MaterielSVG]
        },
        {
            label: 'Héb.  + Skipass + Matériel',
            values: [
                {
                    field: 'packages',
                    id: 'OPPFP6'
                }
            ],
            icons: [HebergementSVG, SkipassSVG, MaterielSVG]
        },
        {
            label: 'Héb.  + Skipass + Matériel',
            values: [
                {
                    field: 'packages',
                    id: 'OPPFP7'
                }
            ],
            icons: [HebergementSVG, SkipassSVG, MaterielSVG]
        },
        {
            label: 'Héb.  + Skipass + Matériel',
            values: [
                {
                    field: 'packages',
                    id: 'OPPFP8'
                }
            ],
            icons: [HebergementSVG, SkipassSVG, MaterielSVG]
        },
        {
            label: 'Héb.  + Skipass + Matériel + Panier de courses',
            values: [
                {
                    field: 'packages',
                    id: 'OPPTC'
                }
            ],
            icons: [HebergementSVG, SkipassSVG, MaterielSVG]
        },
        {
            label: 'Héb.  + Skipass + Matériel + Panier de courses',
            values: [
                {
                    field: 'packages',
                    id: 'OPPTC6'
                }
            ],
            icons: [HebergementSVG, SkipassSVG, MaterielSVG]
        },
        {
            label: 'Héb.  + Skipass + Matériel + Panier de courses',
            values: [
                {
                    field: 'packages',
                    id: 'OPPTC8'
                }
            ],
            icons: [HebergementSVG, SkipassSVG, MaterielSVG]
        },
        {
            label: 'Hôtel + Demi-pension',
            values: [
                {
                    field: 'packages',
                    id: 'CVDP'
                }
            ],
            icons: [HebergementSVG]
        },
        {
            label: 'Hôtel + Demi-pension',
            values: [
                {
                    field: 'packages',
                    id: 'CVPC'
                }
            ],
            icons: [HebergementSVG]
        },
        {
            label: 'Hôtel + Petit-déjeuner',
            values: [
                {
                    field: 'packages',
                    id: 'CVPD'
                }
            ],
            icons: [HebergementSVG]
        },
        {
            label: 'Hotel + All inclusive',
            values: [
                {
                    field: 'packages',
                    id: 'CVAL'
                }
            ],
            icons: [HebergementSVG]
        },
        {
            label: 'PFCS3N3JS',
            values: [
                {
                    field: 'packages',
                    id: 'PFCS3N3JS'
                }
            ],
            icons: [HebergementSVG]
        }
    ],
    en_US: [
        {
            label: 'Train + Accom. + Ski pass',
            values: [
                {
                    field: 'packages',
                    id: 'PFTT'
                }
            ],
            icons: [TrainSVG, HebergementSVG, SkipassSVG]
        },
        {
            label: 'Accommodation',
            values: [
                {
                    field: 'packages',
                    id: 'HS'
                }
            ],
            icons: [HebergementSVG]
        },
        {
            label: 'Accom. + Ski pass',
            values: [
                {
                    field: 'packages',
                    id: 'PF'
                }
            ],
            icons: [HebergementSVG, SkipassSVG]
        },
        {
            label: 'Accom. + Ski pass - Short stay',
            values: [
                {
                    field: 'packages',
                    id: 'PFCS'
                }
            ],
            icons: [HebergementSVG, SkipassSVG]
        },
        {
            label: 'Accom. + Ski pass + Equipment',
            values: [
                {
                    field: 'packages',
                    id: 'PFP'
                }
            ],
            icons: [HebergementSVG, SkipassSVG, MaterielSVG]
        },
        {
            label: 'Accom. + Ski pass + Equipment - Short stay ',
            values: [
                {
                    field: 'packages',
                    id: 'PFPCS'
                }
            ],
            icons: [HebergementSVG, SkipassSVG, MaterielSVG]
        },
        {
            label: 'Accom. + Pass Multi Activities',
            values: [
                {
                    field: 'packages',
                    id: 'PMA'
                }
            ],
            icons: [HebergementSVG]
        },
        {
            label: 'Hotel + Half Board',
            values: [
                {
                    field: 'packages',
                    id: 'CVDP'
                }
            ],
            icons: [HebergementSVG]
        },
        {
            label: 'Hotel + Full Board',
            values: [
                {
                    field: 'packages',
                    id: 'CVPC'
                }
            ],
            icons: [HebergementSVG]
        },
        {
            label: 'Hotel + Breakfast',
            values: [
                {
                    field: 'packages',
                    id: 'CVPD'
                }
            ],
            icons: [HebergementSVG]
        },
        {
            label: 'Hotel + All inclusive',
            values: [
                {
                    field: 'packages',
                    id: 'CVAL'
                }
            ],
            icons: [HebergementSVG]
        }
    ],
    nl_NL: [
        {
            label: 'Accom. + Skipas + Gratis Skimateriaal',
            values: [
                {
                    field: 'packages',
                    id: 'PFP'
                }
            ],
            icons: [HebergementSVG, SkipassSVG, MaterielSVG]
        },
        {
            label: 'Accom. + Skipas + Gratis Skimateriaal - Kort verblijf',
            values: [
                {
                    field: 'packages',
                    id: 'PFPCS'
                }
            ],
            icons: [HebergementSVG, SkipassSVG, MaterielSVG]
        },
        {
            label: 'Accommodatie',
            values: [
                {
                    field: 'packages',
                    id: 'HS'
                }
            ],
            icons: [HebergementSVG]
        },
        {
            label: 'Accom. + Skipas',
            values: [
                {
                    field: 'packages',
                    id: 'PF'
                }
            ],
            icons: [HebergementSVG, SkipassSVG]
        },
        {
            label: 'Trein + Accom. + Skipas',
            values: [
                {
                    field: 'packages',
                    id: 'PFTT'
                }
            ],
            icons: [TrainSVG, HebergementSVG, SkipassSVG]
        },
        {
            label: 'Accom. + Skipas - Kort verblijf',
            values: [
                {
                    field: 'packages',
                    id: 'PFCS'
                }
            ],
            icons: [HebergementSVG, SkipassSVG]
        },

        {
            label: 'Accom. + Activiteitenpas',
            values: [
                {
                    field: 'packages',
                    id: 'PMA'
                }
            ],
            icons: [HebergementSVG]
        },
        {
            label: 'Accom. + Skipas',
            values: [
                {
                    field: 'packages',
                    id: 'PFDW'
                }
            ],
            icons: [HebergementSVG, SkipassSVG]
        },
        {
            label: 'Hotel + Halfpension',
            values: [
                {
                    field: 'packages',
                    id: 'CVDP'
                }
            ],
            icons: [HebergementSVG]
        },
        {
            label: 'Hotel + Volpension',
            values: [
                {
                    field: 'packages',
                    id: 'CVPC'
                }
            ],
            icons: [HebergementSVG]
        },
        {
            label: 'Hotel + Ontbijt',
            values: [
                {
                    field: 'packages',
                    id: 'CVPD'
                }
            ],
            icons: [HebergementSVG]
        },
        {
            label: 'Hotel + All inclusive',
            values: [
                {
                    field: 'packages',
                    id: 'CVAL'
                }
            ],
            icons: [HebergementSVG]
        }
    ]
}

export default packConfig
